import { useState } from "react";
import { Field } from "formik";

import SoftBox from "components/SoftBox";
import SoftInput from "components/SoftInput";

import { CountrySelector, usePhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import "./style.css";

const CountrySelectPhoneInput = ({ name, setFieldValue, international, ...rest }) => {
  const [phonePlaceholder, setPhonePlaceholder] = useState("+1");

  const { country, setCountry } = usePhoneInput({
    defaultCountry: "us",
    disableFormatting: true,
    disableDialCodeAndPrefix: false,
    showDisabledDialCodeAndPrefix: true,
    value: rest.value ?? "",
    onChange: ({ country }) => {
      setPhonePlaceholder(`+${country.dialCode}`);
    },
  });

  return (
    <SoftBox display="flex" alignItems="center">
      <CountrySelector
        className="country-select-phone-input__selector"
        selectedCountry={country.iso2}
        preferredCountries={["us"]}
        buttonStyle={{
          height: "39.5px",
          paddingLeft: "4px",
          borderRightWidth: 0,
          borderTopLeftRadius: "8px",
          borderBottomLeftRadius: "8px",
          "&:hover": { backgroundColor: "none !important" },
          // borderColor: rest.error && "#fd5c70",
        }}
        onSelect={({ iso2, dialCode }) => {
          const countryCode = `+${dialCode}`;
          setCountry({ iso2, dialCode: countryCode });
          setFieldValue(name, countryCode);
        }}
        disabled={rest.disabled}
      />
      <Field
        {...rest}
        style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0, borderLeftWidth: 0 }}
        name={name}
        as={SoftInput}
        onChange={(e) => {
          const inputValue = e.target.value.replace(/\D/g, "");
          const formattedValue = inputValue.startsWith(country.dialCode.replace("+", ""))
            ? `+${inputValue}`
            : `+${country.dialCode}${inputValue}`;

          setFieldValue(name, formattedValue);
        }}
        placeholder={phonePlaceholder}
      />
    </SoftBox>
  );
};

export default CountrySelectPhoneInput;
